import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap5';

import routes from 'app/routes';
import Program from 'components/ProgramBuilder/Program';
import useLoadTopics from 'components/new_ui/Hooks/useLoadTopics';
import { getItems } from 'components/ProgramBuilder/Storage';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import StepTab from 'components/new_ui/Tabs/StepTab';
import Alert from 'components/new_ui/Alerts/alert';

const selectedSteps = (topics, steps) => {
  const arr = [];
  steps.forEach((step, index) => {
    if (step.topic) {
      const topic = topics.find((item) => item.id === step.topic.id);
      if (topic) {
        arr.push({
          position: index + 1,
          topic,
        });
      }
    }
  });
  return arr;
};

export default function OrderTopics({ enterpriseId }) {
  const { state } = useLocation();
  const [selectedTopics, setSelectedTopics] = useState((state && state.selectedTopics) || null);
  const [data, setData] = useState((state && state.data) || {});

  const { topics } = useLoadTopics({ enterprise_id: enterpriseId });
  const [templateAttribute, setTemplateAttribute] = useState(null);

  const navigate = useNavigate();

  const onChange = (value) => {
    setData(value);
  };

  const onContinue = () => {
    const errorMessages = [];
    if (data.programName === '') {
      errorMessages.push('set your Program name');
    }
    if (data.sessionsTopics == null || data.sessionsTopics.length < data.countSessions) {
      errorMessages.push('assign a topic to each step of your Program before you continue');
    }

    if (errorMessages.length > 0) {
      Alert({
        title: 'Build Program',
        text: `You're almost finished! Please ${errorMessages.join(' and ')}.`,
        confirmButtonText: 'Close',
      });
    } else {
      navigate(
        routes.managers.templates.summary,
        {
          state: {
            data,
            selectedTopics,
            template: state.template,
          },
        },
      );
    }
  };

  useEffect(() => {
    if (topics.length === 0) {
      return;
    }
    if (selectedTopics == null) {
      const cacheSelectedTopics = getItems();
      setSelectedTopics(topics.filter((topic) => cacheSelectedTopics.includes(topic.id)));
    }

    setTemplateAttribute({
      title: data?.programName || state.template.attributes.title || '',
      sessions: data?.countSessions || state.template.attributes.sessions || 6,
      steps: data?.sessionsTopics || selectedSteps(topics, state.template.attributes.steps) || [],
    });
  }, [topics]);

  return (
    <>
      <StepTab total={3} current={2} />

      <div className="content">
        <section>
          <h1 className="mb-3">Order Selected Topics</h1>

          <p>
            Drag and drop your topics from left to right in any order of your choice.
            Choose a new topic for each session or dig deeper with the same topic for
            multiple sessions. But don’t stress — you will be able to make program changes
            later.
          </p>
        </section>

        {templateAttribute === null && (
          <section>
            <LoadingPlaceholder text="Build program..." />
          </section>
        )}

        {templateAttribute && (
          <>
            <section>
              <Program
                enterpriseId={enterpriseId}
                selectedTopics={selectedTopics}
                templateAttribute={templateAttribute}
                onChange={onChange}
              />
            </section>

            <footer className="d-flex justify-content-between">
              <Link
                to={routes.managers.templates.chooseTopics}
                className="btn btn-outline-primary"
                state={{
                  data,
                  selectedTopics,
                  template: state.template,
                }}
              >
                Previous
              </Link>

              <Button
                onClick={onContinue}
              >
                Next
              </Button>
            </footer>
          </>
        )}
      </div>
    </>
  );
}

OrderTopics.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
